import { useRef, useEffect } from "react";
import { Bold, Italic, Underline, List, ListOrdered, Link2, Image as ImageIcon, Heading, Eraser } from "lucide-react";

const cmd = (c, v = null) => document.execCommand(c, false, v);

export default function RichTextEditor({ value, onChange, placeholder, testid }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
  }, [value]);

  const emit = () => onChange?.(ref.current?.innerHTML || "");
  const run = (c, v) => { ref.current?.focus(); cmd(c, v); emit(); };
  const safeUrl = (u) => /^(https?:|mailto:)/i.test((u || "").trim());
  const addLink = () => { const u = window.prompt("URL du lien :", "https://"); if (u && safeUrl(u)) run("createLink", u.trim()); else if (u) window.alert("URL invalide (http, https ou mailto uniquement)."); };
  const addImage = () => { const u = window.prompt("URL de l'image :", "https://"); if (u && safeUrl(u)) run("insertImage", u.trim()); else if (u) window.alert("URL invalide (http ou https uniquement)."); };

  const Btn = ({ icon: Icon, onClick, title, tid }) => (
    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={onClick} title={title} data-testid={tid}
      className="h-8 w-8 inline-flex items-center justify-center rounded-md text-foreground/70 hover:bg-white/10 hover:text-foreground transition">
      <Icon className="h-4 w-4" />
    </button>
  );

  return (
    <div className="rounded-md border border-input bg-background overflow-hidden" data-testid={testid}>
      <div className="flex flex-wrap items-center gap-0.5 border-b border-white/10 p-1 bg-white/[0.03]">
        <Btn icon={Bold} onClick={() => run("bold")} title="Gras" tid={`${testid}-bold`} />
        <Btn icon={Italic} onClick={() => run("italic")} title="Italique" tid={`${testid}-italic`} />
        <Btn icon={Underline} onClick={() => run("underline")} title="Souligné" />
        <Btn icon={Heading} onClick={() => run("formatBlock", "H2")} title="Titre" />
        <span className="mx-1 h-5 w-px bg-white/10" />
        <Btn icon={List} onClick={() => run("insertUnorderedList")} title="Liste à puces" />
        <Btn icon={ListOrdered} onClick={() => run("insertOrderedList")} title="Liste numérotée" />
        <span className="mx-1 h-5 w-px bg-white/10" />
        <Btn icon={Link2} onClick={addLink} title="Lien" tid={`${testid}-link`} />
        <Btn icon={ImageIcon} onClick={addImage} title="Image / logo" tid={`${testid}-image`} />
        <span className="mx-1 h-5 w-px bg-white/10" />
        <Btn icon={Eraser} onClick={() => run("removeFormat")} title="Effacer le format" />
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={emit}
        data-placeholder={placeholder}
        data-testid={`${testid}-area`}
        className="rte-content min-h-[140px] max-h-[320px] overflow-y-auto px-3 py-2 text-sm focus:outline-none [&_h2]:text-lg [&_h2]:font-semibold [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:text-emerald-400 [&_a]:underline [&_img]:max-w-full [&_img]:rounded"
      />
    </div>
  );
}
